import React, { useState, useEffect } from 'react';

/**
 * RecentCompares — Shows recently compared products from localStorage
 * Tracks products the user has searched/compared for quick repeat access.
 */
const RecentCompares = ({ onCompare }) => {
  const [recents, setRecents] = useState([]);

  useEffect(() => {
    try {
      const stored = localStorage.getItem('pricepal_recent_compares');
      if (stored) {
        const parsed = JSON.parse(stored);
        setRecents(Array.isArray(parsed) ? parsed.slice(0, 4) : []);
      }
    } catch {
      setRecents([]);
    }
  }, []);

  if (recents.length === 0) return null;

  return (
    <div className="mb-5">
      <p className="text-[11px] font-semibold text-gray-400 uppercase tracking-wider mb-2" data-testid="recent-compares-label">
        Recent Compares
      </p>
      <div className="flex gap-2 overflow-x-auto pb-1 -mx-1 px-1">
        {recents.map((item, i) => (
          <button
            key={i}
            onClick={() => onCompare(item.barcode, item.name)}
            className="flex-shrink-0 bg-white rounded-xl py-2.5 px-3 border border-gray-100 hover:border-green-300 hover:shadow-sm transition-all active:scale-[0.97] min-w-[120px] max-w-[150px]"
            data-testid={`recent-compare-${i}`}
          >
            <p className="text-xs font-semibold text-gray-700 leading-tight line-clamp-2 mb-1">{item.name}</p>
            {item.price && (
              <p className="text-[11px] font-bold text-green-600">from £{item.price}</p>
            )}
          </button>
        ))}
      </div>
    </div>
  );
};

/**
 * Utility: Track a product comparison in localStorage
 */
export const trackCompare = (barcode, name, price) => {
  try {
    const stored = localStorage.getItem('pricepal_recent_compares');
    let recents = stored ? JSON.parse(stored) : [];
    // Remove duplicates
    recents = recents.filter(r => r.barcode !== barcode);
    // Add to front
    recents.unshift({ barcode, name, price: price ? price.toFixed(2) : null, ts: Date.now() });
    // Keep max 8
    recents = recents.slice(0, 8);
    localStorage.setItem('pricepal_recent_compares', JSON.stringify(recents));
  } catch {
    // Silently fail
  }
};

export default RecentCompares;
